module.exports = __webpack_public_path__ + "static/media/poke.f3add7ff.jpg";